import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { get, post } from "../../../../common/api"
import { CUSTOMERS,  CUSTOMERS_ADD } from '../../../../common/constant'

export const actionCustomers = createAsyncThunk('appCustomer/actionCustomers', async (thunkAPI) => {
    return await get(CUSTOMERS, thunkAPI)
})

export const actionAddCustomers = createAsyncThunk('appCustomer/actionAddCustomers', async (params, thunkAPI) => {
    return await post(CUSTOMERS_ADD, params, thunkAPI)
})

export const appCustomerSlice = createSlice({
    name: 'appCustomerSlice',
    initialState: {
        loadingCustomer: false,
        customers: null,

        loadingAddCustomer: false,
        addCustomers: null
    },
    reducers: {
        //reset or delete Add store data
        resetCustomersResponse: (state) => {
            state.customers = null
        },
        resetAddCustomersResponse: (state) => {
            state.addCustomers = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionCustomers.pending, (state) => {
                state.loadingCustomer = true
            })
            .addCase(actionCustomers.fulfilled, (state, action) => {
                state.loadingCustomer = false
                state.customers = action.payload
            })
            .addCase(actionCustomers.rejected, (state) => {
                state.loadingCustomer = false
            })

            //Add
            .addCase(actionAddCustomers.pending, (state) => {
                state.loadingAddCustomer = true
            })
            .addCase(actionAddCustomers.fulfilled, (state, action) => {
                state.loadingAddCustomer = false
                state.addCustomers = action.payload
            })
            .addCase(actionAddCustomers.rejected, (state) => {
                state.loadingAddCustomer = false
            })


    }
})
export const { resetCustomersResponse, resetAddCustomersResponse} = appCustomerSlice.actions

export default appCustomerSlice.reducer